import React, { useEffect, useRef, useState } from 'react';

import { useJsApiLoader } from '@react-google-maps/api';

import { apiKeyGMap, defaultCoords, geocodeAddress } from './utils';

type Props = {
  className?: string;
  coordinates?: { lat: number; lng: number };
  address?: string;
  pov?: { heading: number; pitch: number };
  zoom?: number;
  height?: string;
};

const StreetView: React.FC<Props> = ({
  className = '',
  coordinates,
  address,
  pov = { heading: 100, pitch: 0 },
  zoom = 1,
  height = '500px',
}) => {
  const panoRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState(coordinates || defaultCoords);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: apiKeyGMap,
    libraries: ['places'],
  });

  useEffect(() => {
    if (!coordinates && address && isLoaded) {
      geocodeAddress(address)
        .then((coords) => {
          if (coords) setPosition(coords);
          else console.warn('[StreetView] Geocode returned null');
        })
        .catch((err) => {
          console.error('[StreetView] Geocode error:', err);
        });
    }
  }, [isLoaded, address, coordinates]);

  useEffect(() => {
    if (isLoaded && panoRef.current && window.google?.maps?.StreetViewPanorama) {
      new window.google.maps.StreetViewPanorama(panoRef.current, {
        position,
        pov,
        zoom,
        visible: true,
      });
    }
  }, [isLoaded, position, pov, zoom]);

  if (loadError) {
    return <div className={className}>Failed to load Street View.</div>;
  }

  if (!isLoaded) {
    return (
      <div className={className} style={{ height }}>
        Loading Street View...
      </div>
    );
  }

  return <div className={className} style={{ height }} ref={panoRef} />;
};

export default StreetView;
